<template>
    <div>
        <div class="pb-2">
            <a :href="$urlHelper.getPageUrl('UserAccounts')"
               class="btn btn-primary">
                <i class="fas fa-users"></i>&nbsp;&nbsp;Total users&nbsp;&nbsp;<span class="badge badge-light">{{ userInfoData.totalUserCount }}</span>
            </a>
        </div>
        <div class="pb-2">
            <a :href="$urlHelper.getPageUrl('UserAccounts')"
               class="btn btn-primary"
               v-if="userInfoData.notValidatedUserCount == 0">
                <i class="fas fa-question"></i>&nbsp;&nbsp;Not validated users&nbsp;&nbsp;<span class="badge badge-light">{{ userInfoData.notValidatedUserCount }}</span>
            </a>
            <a :href="$urlHelper.getPageUrl('UserAccounts')"
               class="btn btn-warning"
               v-if="userInfoData.notValidatedUserCount != 0">
                <i class="fas fa-question"></i>&nbsp;&nbsp;Not validated users&nbsp;&nbsp;<span class="badge badge-light">{{ userInfoData.notValidatedUserCount }}</span>
            </a>
        </div>
        <div class="pb-2">
            <a :href="$urlHelper.getPageUrl('UserAccounts')"
               class="btn btn-primary"
               v-if="userInfoData.lockedUserCount == 0">
                <i class="fas fa-user-lock"></i>&nbsp;&nbsp;Locked users&nbsp;&nbsp;<span class="badge badge-light">{{ userInfoData.lockedUserCount }}</span>
            </a>
            <a :href="$urlHelper.getPageUrl('UserAccounts')"
               class="btn btn-warning"
               v-if="userInfoData.lockedUserCount != 0">
                <i class="fas fa-user-lock"></i>&nbsp;&nbsp;Locked users&nbsp;&nbsp;<span class="badge badge-light">{{ userInfoData.lockedUserCount }}</span>
            </a>
        </div>
    </div>   
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';

    import Visibility from 'visibilityjs';

    import ErrorsMixin from '../../../mixins/ErrorsMixin';

    Vue.use(BootstrapVue);
   
    export default {
        name: 'UsersInfoWidget',
        mixins: [ErrorsMixin],
        props: {
            dashboardWidgetConfigurationId: {
                type: String,
                default: null
            },    
            title: {
                type: String,
                default: null
            },
            configuration: {
                type: Object,
                default: null
            },
            widgetMode: {
                type: String,
                default: 'view'
            }
        },
        data: function () {
            return {
                userInfoData: [],
                timer: null,
                refreshIntervalInMilliseconds: 60000
            }
        },
        methods: {  
            loadData: function () {   
                if (this.dashboardWidgetConfigurationId) {
                    var url = this.$urlHelper.getApiUrl('dashboardwidget', 'data', ['usersinfo', this.dashboardWidgetConfigurationId, 'null']);
                    // providing the null at the end of the url indicates that this widget does not want to deal with time ranges
                    axios
                        .get(url)
                        .then(response => {
                            this.userInfoData = response.data;
                        })
                        .catch(ex => {
                            console.log(JSON.stringify(ex));
                            var currentErrors = this.handleAxiosException(ex);
                            this.showErrorsToast(currentErrors);
                        });
                }
            },
            reloadData: function () {
                if (this.widgetMode == 'view') {
                    this.loadData();
                }
            },
        },
        updated: function () {

        },
        mounted: function () {
           
            this.loadData();
            this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.reloadData);
        }
    }
</script>
